import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../../app/store";
import {User, LoginUser, list as listUsers} from "../../../services/UsersService";

interface MoveLoginUserModalState {
  isOpened: boolean;
  loginUser: LoginUser | null;
  users: User[];
  selectedUser: User | null;
  selectedRole: LoginUser["role"] | null;
}

const initialState: MoveLoginUserModalState = {
  isOpened: false,
  loginUser: null,
  users: [],
  selectedUser: null,
  selectedRole: null
};

export const findUser = createAsyncThunk("moveLoginUserModa/findUser", async (filter: string) => {
  return await listUsers(0, 5, filter);
});

const moveLoginUserModalSlice = createSlice({
  name: "moveLoginUserModal",
  initialState,
  reducers: {
    open: (state, action: PayloadAction<LoginUser>) => {
      state.isOpened = true;
      state.loginUser = action.payload;
      // Least-privilege default: never carry the source-account role (e.g.
      // superAdmin) into the target account unless the agent picks it.
      state.selectedRole = "teamMember";
    },
    close: () => initialState,
    selectUser: (state, action: PayloadAction<User>) => {
      state.selectedUser = action.payload;
    },
    selectRole: (state, action: PayloadAction<LoginUser["role"]>) => {
      state.selectedRole = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(findUser.fulfilled, (state, action: PayloadAction<Array<User>>) => {
      state.users = action.payload;
    });
  }
});

export default moveLoginUserModalSlice.reducer;
export const moveLoginUserModalState = (state: RootState): MoveLoginUserModalState => state.moveLoginUserModal;
export const {open, close, selectUser, selectRole} = moveLoginUserModalSlice.actions;
